import { ColDef, ICellRendererParams, RowNode } from "ag-grid-community";
import { AggFuncs, Item } from "constants/product-collection";
import { nullish } from "helpers/nullish";
import { parseAssortmentName } from "helpers/product-collection";
import { AGGREGATE_COLUMN_PREFIX, ASSORTMENT_NAME_DELIMITER, getBlankTextValue } from "helpers/server-rollup";
import React from "react";

export const AG_GRID_AUTOCOLUM = "ag-Grid-AutoColumn";
export const NUMERIC_COLUMN = "numericColumn";

export const getServerSideAggregateValueFormatted = (
    { node, colDef, data, formatValue, valueFormatted }: ICellRendererParams,
    initialFormattedValue?: string
) => {
    if (node.group && data) {
        const aggregateField = data.fields[`${AGGREGATE_COLUMN_PREFIX}${colDef.colId}`];
        const fieldType = aggregateField?.hasOwnProperty("number_value") ? "number_value" : "string_value";
        const isStringAggregation = fieldType === "string_value";
        const newValue = aggregateField?.[fieldType];

        return (
            (!nullish(newValue) &&
                colDef.type === NUMERIC_COLUMN &&
                !isStringAggregation &&
                newValue &&
                formatValue(newValue)) ||
            newValue
        );
    }

    return !initialFormattedValue ? valueFormatted : initialFormattedValue;
};

export const getUnsetGroupKeyDisplayValue = (node: RowNode, colDef: ColDef) =>
    node.group && colDef.colId === AG_GRID_AUTOCOLUM ? getBlankTextValue() : null;

export const extractAssortmentNameIfNeeded = (value: string, colDef: ColDef, node: RowNode) => {
    if (
        (!colDef || colDef.colId === AG_GRID_AUTOCOLUM) &&
        node.group &&
        node.field === Item.FIELDS.ASSORTMENT_FIELD_NAME[1]
    ) {
        return parseAssortmentName(value || "", ASSORTMENT_NAME_DELIMITER).assortmentName;
    }
    return value;
};

export const renderGroupCount = (
    { colDef, node, data, context }: ICellRendererParams,
    domElementIsPreferred?: boolean
) => {
    const { isServerSide: serverMode } = colDef?.cellRendererParams || {};
    const isServerSide = serverMode || context?.isServerRollup;
    if (!isServerSide || !node.group || !data || !colDef || colDef.colId !== AG_GRID_AUTOCOLUM) {
        return null;
    }

    if (domElementIsPreferred) {
        const domElement = document.createElement("span");
        domElement.style.paddingLeft = "4px";
        domElement.textContent = `(${data.itemCount || 0})`;
        return domElement;
    }
    return <span style={{ paddingLeft: 4 }}>({data.itemCount || 0})</span>;
};

export const isStringAggregationFunction = (colDef: ColDef) =>
    [AggFuncs.COUNT_WITH_PERCENT, AggFuncs.SUM_WITH_PERCENT].includes(colDef?.aggFunc as string);
